// Données statiques des cours
// Tous les cours sont maintenant inclus dans le pass global

export const coursesData = [
  {
    id: 'baseprogrammation',
    title: 'Les bases de la Programmation',
    description: 'Apprends les bases de la programmation',
    level: 'Débutant',
    courseUrl: '/cours/baseprogrammation',
    highlights: [
      'Variables et types de données',
      'Conditions et boucles',
      'Fonctions et structures',
      'Exercices pratiques'
    ],
    displayOrder: 1,
    isFree: true,
    seoKeywords: 'bases programmation, variables, conditions, boucles, fonctions, débutant, JavaScript, p5.js'
  },
  {
    id: 'ameliorevisée',
    title: 'Jeu 1 : Améliore ta visée',
    description: 'Code ton premier jeu ultra simple qui permet d\'entrainer ta visée !',
    level: 'Débutant',
    courseUrl: '/cours/ameliorevisée',
    highlights: [
      'Boucle de jeu fondamentale',
      'Gestion des clics souris',
      'Système de score et timer',
      'Interface de jeu complète'
    ],
    isFree: true,
    displayOrder: 2
  },
  {
    id: 'morpion',
    title: 'Jeu 2 : Morpion',
    description: 'Code ton jeu de Morpion !',
    level: 'Intermédiaire',
    courseUrl: '/cours/morpion',
    highlights: [
      'Création du plateau de jeu',
      'Détection des interactions',
      'Gestion de grilles de jeu',
      'Logique de victoire'
    ],
    displayOrder: 3,
    seoKeywords: 'morpion, tic-tac-toe, plateau jeu, logique victoire, interactions utilisateur'
  },
  {
    id: 'flappybird',
    title: 'Jeu 3 : Flappy Bird',
    description: 'Le remake de Flappy Bird !',
    level: 'Expert',
    courseUrl: '/cours/flappybird',
    highlights: [
      'Affichage de sprites',
      'Détection de collisions',
      'Système de score',
      'Sons et effets visuels'
    ],
    displayOrder: 4,
    seoKeywords: 'flappy bird, animation, collisions, score, sons, effets visuels'
  },
  {
    id: 'snake',
    title: 'Jeu 4 : Snake',
    description: 'Le célébre jeu Snake',
    level: 'Expert',
    courseUrl: '/cours/snake',
    highlights: [
      'Mouvement du serpent',
      'Gestions d\'une liste',
      'Gestion des collisions',
      'Système de croissance'
    ],
    displayOrder: 5,
    seoKeywords: 'snake, serpent, grille, mouvement, contrôles clavier, collision, croissance'
  }
];

// Fonction pour obtenir tous les cours (remplace l'appel Firebase)
export const getAllCoursesStatic = () => {
  return coursesData.filter(course => course.displayOrder > 0);
};

// Fonction pour obtenir un cours par ID (remplace l'appel Firebase)
export const getCourseByIdStatic = (courseId) => {
  const course = coursesData.find(c => c.id === courseId);
  if (!course) {
    throw new Error('Cours non trouvé');
  }
  return course;
}; 